import { graphql, useStaticQuery } from 'gatsby'
import { useIntl } from 'react-intl'

import { adaptStrapiGlobalImage } from '@utils/cms/mapStrapiModules'
import { strapiProfileUrl } from '@utils/cms/strapiPageContext'
import { defaultLang } from '../../../../translations'
import '../../../../schema/fragments/StrapiJobPageFields'

const useStrapiPageJobProfile = (): MCDC.Contentful.IPageProfileLink[] => {
  const { locale } = useIntl()
  const activeLocale = locale || defaultLang
  const { offers, data } = useStaticQuery(
    graphql`
      query StrapiPageJobProfileStaticQuery {
        offers: allStrapiPageGeneric(filter: { metaType: { eq: "offers" } }) {
          nodes {
            path
          }
        }
        data: allStrapiPageProfile {
          nodes {
            id
            identifier
            title
            imageTeaser {
              ...StrapiGlobalImageFields
            }
          }
        }
      }
    `
  )

  const offersBaseUrl: string = offers.nodes[0]?.path || '/'

  return (
    data.nodes?.map(
      (entry: {
        id: string
        identifier?: string
        title?: string
        imageTeaser?: Parameters<typeof adaptStrapiGlobalImage>[0]
      }): MCDC.Contentful.IPageProfileLink => {
        const url = strapiProfileUrl(offersBaseUrl, entry.identifier)

        return {
          id: entry.id,
          node_locale: activeLocale,
          identifier: entry.identifier || '',
          title: entry.title || '',
          imageTeaser: adaptStrapiGlobalImage(entry.imageTeaser),
          fields: {
            linkTo: {
              label: entry.title || '',
              url,
              isExternal: false,
            },
            breadcrumbs: [],
          },
        }
      }
    ) || []
  )
}

export default useStrapiPageJobProfile
